/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import axios from "axios";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";

import Datetime from 'react-datetime';
import Select from 'react-select';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Fab from '@material-ui/core/Fab';

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Typography from "@material-ui/core/Typography";
import MailIcon from '@material-ui/icons/Mail';
import Hidden from '@material-ui/core/Hidden';

// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import "./accrued-style.css";
import { time } from "highcharts";



const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: "gray",
  },
};

const primaryColor = "#af2cc5";

const useStyles2 = makeStyles((theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
   paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  largeAvatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
    fontFamily: '"Sarabun", sans-serif',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
    fontFamily: '"Sarabun", sans-serif',
  },
}));


function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, nodeType, nodeVal, onTreeClick, ...other } = props;
  

  return (
    <TreeItem
      //onLabelClick={handleClick(nodeType, nodeVal)}
    
      onLabelClick={onTreeClick}
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
    );
  }

// const data = [
//   {
//     employeeId: '01',
//     name: 'John Doe',
//     email: 'johndoe@email.com',
//     position: 'Frontend Developer',
//   },
//   {
//     employeeId: '02',
//     name: 'Sara',
//     email: 'sara@email.com',
//     position: 'HR Executive',
//   },
//   {
//     employeeId: '03',
//     name: 'Mike',
//     email: 'mike@email.com',
//     position: 'Backend Developer',
//   },
// ]

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    //maxWidth: 400,
  },
  cardXs: {
      width: 75,
      height: 110,
      paddingTop: 10,
      margin:2,
      textAlign: 'center',
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
      "&:hover": {
          boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
      }
  },
  cardSm: {
    width: 180,
    height: 140,
    textAlign: 'center',
    margin: "3px",
    transition: "0.3s",
    display: "inline-block",
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
    }
  },
  cardImg1: {
      width: 60, height: 60, borderRadius: 60 / 2, objectFit: 'cover', objectPosition: '100% 0'
  },
  cardImg2: {
      width: 100, height: 100, borderRadius: 100 / 2, objectFit: 'cover', objectPosition: '100% 0'
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "16px",
    marginTop: "10px",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
});


const AccruedLeave = (props) => {
  var moment = require('moment');
  require('moment/locale/th');

  const [modal, setModal] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  // const [employeeData, setEmployeeData] = useState(data)
  const [arrMission, setArrMission] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [Param, SetParam] = useState('');
  const [isMultiple, setIsMultiple] = useState((props.isMultiple != null) ? props.isMultiple : '');
  const [isShowAll, setIsShowAll] = useState((props.isShowAll != null && props.isShowAll == true) ? '&isShowAll=true' : '');
  const [optionYear, setOptionYear] = useState([]);
  const [year, setYear] = useState("");
  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  useEffect(() => {
    async function fetchMyAPI() {
       await axios.get("/api/v1/mission/", {})
      .then((response) => {
        setArrMission(response.data.data) 
      });
    }

    fetchMyAPI()
  }, [arrMission.length === 0])

  useEffect(() => {
    axios.get("/api/v1/year/")
    .then(
      result => {
        optionYear.push({ value: 0, label: "กรุณาระบุปีงบประมาณ" });
        result.data.forEach(e => {
          optionYear.push(e);
        });

      },
        error => { 
          console.log(error); 
        }
    );  
  }, [])

  useEffect(() => {
    setDataList([])
  }, [year])

  const onChangeInput = (e, userName) => {
    const { name, value } = e.target
    //console.log(userName);
    //console.log(name);
    //console.log(value);

    const editData = dataList.map((item) =>
      item.userName === userName && name ? { ...item, [name]: value } : item
    )

    setDataList(editData)
    // console.log(editData);

    axios.get("/api/v1/leave/accrued/" + userName + "/" + year)
    .then(
      result => {
          if(result.data.result == 200)
          {
              var accruedLeave = null;

              if (name == 'leave1') {
                  accruedLeave = {
                      userName: userName,
                      leave1: value,
                      calyear: year,
                      lastEditorCode: currentUser.userName
                  };
              }
              else if (name == 'leave2') {
                  accruedLeave = {
                      userName: userName,
                      leave2: value,
                      calyear: year,
                      lastEditorCode: currentUser.userName
                  };
              }
              else if (name == 'leave3') {
                  accruedLeave = {
                      userName: userName,
                      leave3: value,
                      calyear: year,
                      lastEditorCode: currentUser.userName
                  };
              }
              else if (name == 'accruedValue') {
                  accruedLeave = {
                      userName: userName,
                      accruedValue: value,
                      calyear: year,
                      lastEditorCode: currentUser.userName
                  };
              }


            if(result.data.data !== null && result.data.data !== undefined){

                  axios.put("/api/v1/leave/accrued/"+ userName +"/" + year, accruedLeave)
                  .then(
                    result => {
                      if(result.data.result == 200)
                      {
              
                      }
                    },
                      error => { console.log(error); }


                );  
            }
            else if (result.data.data === null) {
     
              axios.post('/api/v1/leave/accrued', accruedLeave)
              .then(
                result => {
                  if(result.data.result == 200)
                  {
                   
                  }
                }, error => { console.log(error); }
              );  
            }
          } else {
           
          }
        },
        error => {console.log(error); }
    );  
  }

  const classes = useStyles();
  const classes2 = useStyles2();

  const handleClickTree = (type, val) => (e) => {

    //e.preventDefault();
    //console.log(type)
  
    var param = '';

    if(type == 'M')
      param = '?Missionkey='+val;
    else  if(type == 'G')
      param = '?GroupWorkKey='+val;
    else  if(type == 'D')
      param = '?DepartmentKey='+val;
    else  if(type == 'K')
      param = '?FirstName='+val;

    SetParam(param)

    axios.get("/api/v1/leave/accrued/" + param + isShowAll + "&Year=" + year)
    .then(
      result => {
          if(result.data.result == 200)
          {
            setDataList(result.data.data)
            //console.log(dataList);
          }
        },
        error => {console.log(error); }
    );  
  };

  const renderMission = arrMission.map((mission, index) =>
  <StyledTreeItem onTreeClick={handleClickTree('M', mission.missionKey)} nodeType={"M"} nodeVal={mission.missionKey} key={"M"+mission.missionKey.toString()}  nodeId={"M"+mission.missionKey.toString()} labelText={mission.name} labelIcon={MailIcon} >
       
       
       {Array.isArray(mission.groupWork)
        ? mission.groupWork.map((group, index2) => 
          <StyledTreeItem onTreeClick={handleClickTree('G', group.groupWorkKey)}  nodeType={"G"} nodeVal={group.groupWorkKey}  key={"G"+group.groupWorkKey.toString()}  nodeId={"G"+group.groupWorkKey.toString()} labelText={group.name} labelIcon={MailIcon}  >


                  {Array.isArray(group.department)
                    ? group.department.map((dept, index3) => 
                    <Hidden only='xs'>
                    <StyledTreeItem onTreeClick={handleClickTree('D', dept.departmentKey)}  nodeType={"D"} nodeVal={dept.departmentKey} key={"D"+dept.departmentKey.toString()}  nodeId={"D"+dept.departmentKey.toString()} labelText={dept.name} labelIcon={MailIcon} style={{ paddingLeft: '20px'}} >
                  
                      </StyledTreeItem>
                    </Hidden>
                    )
                    : null
                  }


          </StyledTreeItem>
        )
        : null
      }
  </StyledTreeItem>
  );

    return (
      <div>
        <Grid>
          <Col xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary">
                <Grid>
                  <Col xs={12} sm={12} md={3}>
                    <h4 className={classes.cardTitleWhite}>วันลาสะสม</h4>
                  </Col>
                  <Col xs={6} sm={6} md={6} style={{ color: 'black', textAlign: 'left' }}>
                  <TSSelect
                    options={optionYear}
                    onChange={e => setYear(e)}
                    defaulfAdd={optionYear[0]}
                  />
                  </Col>
                  <Col xs={6} sm={6} md={3} style={{ textAlign: 'right' }}>
                  </Col>
                </Grid>
              </CardHeader>
              <CardBody>
              <Grid>
              <Col xs={12} sm={4} md={4}>
                <TreeView
                  className={classes.root}
                  defaultExpanded={['3']}
                  defaultCollapseIcon={<ArrowDropDownIcon />}
                  defaultExpandIcon={<ArrowRightIcon />}
                  defaultEndIcon={<div style={{ width: 24 }} />}
                >
              {renderMission}
        </TreeView>
      </Col>
      {(dataList.length > 0) && (
      <Col xs={12} sm={8} md={8}>
        <div className="container">
          <table>
            <thead>
              <tr>
                <th>ชื่อ</th>
                <th>ลาป่วย</th>
                <th>ลากิจ</th>
                <th>ลาพักผ่อน</th>
                <th>วันลาสะสม</th>
                <th>ปีงบประมาณ</th>
                {/* <th>Position</th> */}
              </tr>
            </thead>
            <tbody>
              {dataList.map(({ userName, fullName, leave1,leave2,leave3, accruedValue, calyear}) => (
               <tr key={userName}>
                  <td>
                    <input
                      name="name"
                      value={fullName}
                      type="text"
                      onChange={(e) => onChangeInput(e, userName)}
                      disabled
                    />
                      </td>
                      <td>
                          {(year > 0) && <input
                              name="leave1"
                              value={leave1}
                              type="number"
                              step="any"
                              //onChange={(e) => SetLeave1(e.target)}
                              onChange={(e) => onChangeInput(e, userName)}
                              placeholder="จำนวน"
                          />
                          }
                      </td>
                      <td>
                          {(year > 0) && <input
                              name="leave2"
                              value={leave2}
                              type="number"
                              step="any"
                              //onChange={(e) => SetLeave2(e.target)}
                              onChange={(e) => onChangeInput(e, userName)}
                              placeholder="จำนวน"
                          />
                          }
                      </td>
                      <td>
                          {(year > 0) && <input
                              name="leave3"
                              value={leave3}
                              type="number"
                              step="any" 
                              //onChange={(e) => SetLeave3(e.target)}
                              onChange={(e) => onChangeInput(e, userName)}
                              placeholder="จำนวน"
                          />
                          }
                      </td>
                  <td>
                  {(year > 0) && <input
                      name="accruedValue"
                      value={accruedValue}
                      type="number"
                      step="any"  
                      onChange={(e) => onChangeInput(e, userName)}
                      placeholder="จำนวน"
                    /> 
                  }
                  {(year === 0) && <input
                      name="accruedValue"
                      value={accruedValue}
                      type="number"
                      step="any"  
                      //onChange={(e) => setAccruedValue(e.target)}
                      onChange={(e) => onChangeInput(e, userName)}
                      placeholder="จำนวน"
                      disabled
                    />
                  }
                  </td>
                  <td>
                    <input
                      name="calyear"
                      value={calyear}
                      type="text"
                      //onChange={(e) => onChangeInput(e, userName)}
                      disabled
                    />
                  </td>
              {/* <td>
                <input
                  name="position"
                  type="text"
                  value={position}
                  onChange={(e) => onChangeInput(e, employeeId)}
                  placeholder="Type Position"
                />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Col>)}
    </Grid>
              </CardBody>
            </Card>
          </Col>
        </Grid>   
      </div>
    );
}
export default AccruedLeave;